import { useEffect, useState, useRef } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';

import basePCUrl from '../../../Globals';
import { fetchApiData } from '../../../utils/service';
import { useQuery } from 'react-query';

export const useGetAlertDetails = (alertId, accessLevel, clientId) => {
  //const [data, setData] = useState([]);

  const { getAccessTokenSilently } = usePortalAuth();

  const { isLoading, data, isError, error } = useQuery(`alertId=${alertId}`, async () => {
    const token = await getAccessTokenSilently();
    return fetchApiData(
      basePCUrl,
      token,
      'getAlertDetails',
      accessLevel,
      clientId
    );
  });
  let alertDetails;
  if (data) {
    alertDetails = data.find((alert) => alert.alertId === alertId);
  }

  return { isLoading, alertDetails, isError, error };
};
export default useGetAlertDetails;
